import { Empty, Result } from "antd"
import { Link } from 'react-router-dom';



const Error404 = () => {



    return (
    <>
      {/* <Empty
    image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
    imageStyle={{
      height: 100,
    }}
    description="Not Found Page"
    style={{fontWeight: "bold"}}
  >
    <Link to="/" className="primary">Main page</Link>
  </Empty> */}

      <Result
        status={404}
        title={404}
        subTitle="Not Found Page"
        extra={<Link to="/">Back Home</Link>}
      />
    </>
  )
}

export default Error404